import {type Maybe, maybeFetchWP} from '../../../frontend/@shared/ts/maybe';
import {type TransactionUpdate} from '../../../frontend/@shared/ts/transaction';
import {type IResponse} from '../../../frontend/@type/response';
import z from 'zod';

import './index.scss';

async function startTransaction(gateway: string): Promise<Maybe<string>> {
	const formData = new FormData();
	formData.append('gateway_id', gateway);
	formData.append('checkout_location', 'checkout-blocks');

	const {error, result} = await maybeFetchWP<IResponse<{transaction_id: string}>>(window.peachpay_checkout_blocks.create_transaction_url, {
		method: 'POST',
		body: formData,
	});

	if (error || !result) {
		return {error};
	}

	if (!result.success || !result.data) {
		return {error: new Error(result.message ?? 'Failed to create transaction.')};
	}

	return {result: result.data.transaction_id};
}

async function updateTransaction(transactionId: string, options: TransactionUpdate): Promise<boolean> {
	try {
		const formData = new FormData();
		formData.append('transaction_id', transactionId);

		if (options.paymentStatus) {
			formData.append('payment_status', options.paymentStatus);
		}

		if (options.orderStatus) {
			formData.append('order_status', options.orderStatus);
		}

		if (options.note) {
			formData.append('note', options.note);
		}

		const response = await fetch(window.peachpay_checkout_blocks.update_transaction_url, {
			method: 'POST',
			body: formData,
		});

		const responseBody = await response.json() as IResponse<void>;

		if (!response.ok || !responseBody.success) {
			return false;
		}

		return true;
	} catch (error) {
		return false;
	}
}

export {
	startTransaction,
	updateTransaction,
	z,
};

declare global {
	interface Window {
		peachpay_checkout_blocks: {
			'create_transaction_url': string;
			'update_transaction_url': string;
			startTransaction: typeof startTransaction;
			updateTransaction: typeof updateTransaction;
			z: typeof z;
		};
	}
}

if (window.peachpay_checkout_blocks) {
	window.peachpay_checkout_blocks.startTransaction = startTransaction;
	window.peachpay_checkout_blocks.updateTransaction = updateTransaction;
	window.peachpay_checkout_blocks.z = z;
} else {
	window.peachpay_checkout_blocks = {
		create_transaction_url: '/?wc-ajax=pp-create-transaction',
		update_transaction_url: '/?wc-ajax=pp-update-transaction',
		startTransaction,
		updateTransaction,
		z,
	};
}
